'use client'

import { useEffect, useState } from 'react'
import { useWordpressStore } from '@repo/store/useWordpressStore'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import { formatDate } from '@repo/utils/time'
import { decodeHTMLentities } from '@repo/utils/htmlEntities'
import { LoadingState } from '@repo/ui/LoadingState'
import { CarouselNavigation } from '@repo/ui/CarouselNavigation'
import styles from './DashboardNews.module.scss'

export const DashboardNews = () => {
  const { newsItems, fetchNewsItems } = useWordpressStore()
  const [newsIndex, setNewsIndex] = useState(0)
  const [currentNewsItem, setCurrentNewsItem] = useState(null)

  useEffect(() => {
    if (!newsItems?.length) return
    const currentNewsItem = newsItems[newsIndex]
    setCurrentNewsItem(currentNewsItem)
  }, [newsIndex, setCurrentNewsItem, newsItems])

  useEffect(() => {
    fetchNewsItems()
  }, [fetchNewsItems])

  if (!currentNewsItem) {
    return (
      <MUIStack
        data-testid="DashboardNews"
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ width: '100%', minHeight: '545px', paddingBottom: '70px' }}
      >
        <LoadingState />
      </MUIStack>
    )
  }

  const image = currentNewsItem._embedded['wp:featuredmedia'][0].source_url || ''
  const imageAltText = currentNewsItem._embedded['wp:featuredmedia'][0].alt_text || ''
  const title = decodeHTMLentities(currentNewsItem.title?.rendered || '')
  const date = formatDate(currentNewsItem.date_gmt || Date.now(), 'EEE, do MMM yyyy')
  const excerpt = decodeHTMLentities(currentNewsItem.excerpt?.rendered || '')

  return (
    <MUIStack
      data-testid="DashboardNews"
      direction="column"
      sx={{ padding: '16px', position: 'relative', minHeight: '545px' }}
    >
      <CarouselNavigation
        items={newsItems}
        index={newsIndex}
        onChange={setNewsIndex}
        sx={{ position: 'absolute', top: '-42px', right: 0, zIndex: 8 }}
      />

      {image ? (
        <a href={currentNewsItem.link} target="_blank" style={{ maxWidth: '100%' }}>
          <img src={image} title={imageAltText} alt={imageAltText} style={{ marginBottom: '24px', width: '100%' }} />
        </a>
      ) : null}

      <MUITypography variant="h5" sx={{ mb: 2, color: 'text.primary', textDecoration: 'none' }}>
        <a className={styles.newsHeading} href={currentNewsItem.link} target="_blank">
          {title}
        </a>
      </MUITypography>

      <MUITypography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        {date}
      </MUITypography>
      <MUITypography variant="body1" sx={{ color: 'text.secondary' }}>
        {excerpt}
      </MUITypography>

      <MUITypography variant="body1" sx={{ color: 'secondary.main', textAlign: 'right', mt: '21px' }}>
        <a href={currentNewsItem.link} className={styles.newsLink} target="_blank">
          Read more
        </a>
      </MUITypography>
    </MUIStack>
  )
}
